<template>
	<div>
		<el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
			<el-table-column type="expand">
				<template>
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="印刷缺陷长度">
							<span>111</span>
						</el-form-item>
						<el-form-item label="QA确认缺陷长度">
							<span>2222</span>
						</el-form-item>
						<el-form-item label="QA调整缺陷长度">
							<span>333</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>

			<el-table-column type="index" label="序号" width="50"> </el-table-column>
			<el-table-column label="批次号" width="80"> </el-table-column>
			<el-table-column label="批次名称"> </el-table-column>
			<el-table-column label="调入来源" width="80"> </el-table-column>
			<el-table-column label="调入时间" width="80"> </el-table-column>
			<el-table-column label="工单号" width="70"> </el-table-column>
			<el-table-column label="工单号" width="80"> </el-table-column>
			<el-table-column label="产品号" width="70"> </el-table-column>
			<el-table-column label="缺陷表" width="100"> </el-table-column>
			<el-table-column label="模板号" width="70"> </el-table-column>
			<el-table-column label="检测总张数" width="100"> </el-table-column>
			<el-table-column label="坏品张数" width="80"> </el-table-column>
			<el-table-column label="总长度" width="70"> </el-table-column>
			<el-table-column label="缺陷个数" width="80"> </el-table-column>
			<el-table-column label="坏品个数" width="80"> </el-table-column>
		</el-table>
	</div>
</template>

<style>
	.demo-table-expand {
		font-size: 0;
	}
	.demo-table-expand label {
		width: 120px;
		color: #99a9bf;
	}
	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 33%;
	}
</style>

<script>
	export default {
		props: {
			mode: {
				type: Number,
			},
		},
		data() {
			return {
				tableData: [
					{
						date: '2016-05-03',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
					{
						date: '2016-05-02',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
					{
						date: '2016-05-04',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
					{
						date: '2016-05-01',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
					{
						date: '2016-05-08',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
					{
						date: '2016-05-06',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
					{
						date: '2016-05-07',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄',
					},
				],
				multipleSelection: [],
			}
		},

		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row)
					})
				} else {
					this.$refs.multipleTable.clearSelection()
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
		},
	}
</script>
